export default "__VITE_ASSET__918258f7__"